const initState = {
  showAlert: false,
  alertType: "",
  alertMessage: "",
  toggleDialog: false,
  togglePrompt: false, 
  weeksInYear: [],
  activeStep: 0,
  wizardHasError: false,
  selectedUserOption: '', 
  isSaving: false   
}


const commonReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SHOW_ALERT_MESSAGE':
      return {
        ...state,
        showAlert: action.show,
        alertType: action.alertType,
        alertMessage: action.message
      }
    case 'TOGGLE_PROMPT':
      return {
        ...state,
        togglePrompt: action.show 
      }
    case 'TOGGLE_DIALOG_BOX':
      return {
        ...state,
        toggleDialog: action.show
      }
    case 'SET_WEEK_IN_YEAR':
      return {
        ...state,
        weeksInYear: action.weeks 
      }
    case 'UPDATE_CURRENT_STEP':
      return {
        ...state, 
        activeStep: action.step
      }
    case 'SET_WIZARD_HAS_ERROR':
      return {
        ...state, 
        wizardHasError: action.hasError  
      }
    case 'SET_SELECTED_USER_OPTION': 
      return {
        ...state,
        selectedUserOption: action.options
      }
    case 'CLEAR_SELECT_USER_OPTION':
      return {
        ...state, 
        selectedUserOption: '' 
      }
    case 'SET_IS_SAVING':
      return {
        ...state, 
        isSaving: action.isSaving 
      }
    case 'RESET_IS_SAVING':
      return {
        ...state, 
        isSaving: false 
      }
    case 'RESET_ACTIVE_STEP':
      return {
        ...state, 
        activeStep: 0 
      }
    default: 
      return state;
  }
}

export default commonReducer